import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-try-again-action-error-alert',
  templateUrl: './try-again-action-error-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TryAgainActionErrorAlertComponent {
  @Input()
  errorTranslationKey: string;

  @Input()
  tryAgainAdditionalTextKey: string;

  @Input()
  tryAgainAction: () => any;

  @Output()
  closeClick = new EventEmitter<void>();

  protected buildTranslationKey(relativeKey: string): string {
    return `core.globalAlerts.tryAgainActionError.${relativeKey}`;
  }

  protected tryAgainClick(): void {
    if (typeof this.tryAgainAction === 'function') {
      this.tryAgainAction();
    }

    this.closeClick.emit();
  }
}
